import React, { useCallback, useEffect, useState } from "react";
import { Form } from "Components/Core";
import { getAcademyList } from "Api/Pages/AcademyApi";
import { AcademyObjectType } from "Interfaces/Pages/AcademyInterface";

interface SelectAcademyPropsType {
  handleSelect: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  selected: string;
  className?: string;
}

const SelectAcademy: React.FC<SelectAcademyPropsType> = ({
  handleSelect,
  selected,
  className,
}) => {
  const [academyList, setAcademyList] = useState<AcademyObjectType[]>([]);

  const fetchAcademyList = useCallback(async () => {
    const data = await getAcademyList({
      page: 1,
      search: "",
      per_page: 1000,
      all_academies: true,
      order_by: "name",
      order_type: "asc",
    });
    setAcademyList(data?.academies || []);
  }, []);

  useEffect(() => {
    fetchAcademyList();
  }, [fetchAcademyList]);

  return (
    <Form.Group className={`${className}`}>
      <Form.Label className="fs-sm">Academy</Form.Label>
      <Form.Select
        className="ss-select-control bg-white"
        aria-label="Academy"
        onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
          handleSelect && handleSelect(event)
        }
        value={selected}
      >
        <option value="" key="All">
          All Academies
        </option>
        {academyList.map((academy) => {
          return (
            <option value={academy.id} key={academy.id}>
              {academy.name}
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  );
};

SelectAcademy.defaultProps = {
  className: "",
};

export default SelectAcademy;
